// extracted by mini-css-extract-plugin
export default {"root":"TermsSection_root__0WjkQ","underlined":"TermsSection_underlined__m+M4H"};